import AxiosInstance from "./api";

export const PettyCashBookService = {
  getPaginate: async (payload) => {
    const query = new URLSearchParams(payload);
    return await AxiosInstance.get("/private/petty-cash-books/paginate", {
      params: query,
    });
  },

  getById: async (id) => {
    return await AxiosInstance.get("/private/petty-cash-books/" + id);
  },

  create: async (payload) => {
    return await AxiosInstance.post("/private/petty-cash-books", payload);
  },

  update: async (id, payload) => {
    return await AxiosInstance.patch("/private/petty-cash-books/" + id, payload);
  },

  delete: async (id) => {
    return await AxiosInstance.delete("/private/petty-cash-books/" + id);
  },
};
